import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

export interface LocalizedTextWrappingProps {
  message: string;
  fieldName: string;
}

export const LocalizedTextWrapping: React.FunctionComponent<LocalizedTextWrappingProps> = ({
  message,
  fieldName,
  children,
}) => {
  const l10n = useLocalization();

  const outerText = l10n.formatText(message).split(`[${fieldName}]`);

  switch (outerText.length) {
    case 1:
      return <>{outerText[0]}</>;

    case 2:
      return (
        <>
          {outerText[0]}
          {children}
          {outerText[1]}
        </>
      );

    default:
      throw new Error(`More than one field called ${fieldName}`);
  }
};
